import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ListImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/listImpression.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: ListImpressionTrackingInfo) => {
    const event: AnalyticsEvent<ListImpressionTrackingInfo> = {
        event: EventType.ListImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};
